<template>
    <BaseModal :id="modalId" dialog-class="modal-dialog-scrollable modal-lg" content-class="p-3">
        <template #header>
                    <h3 class="mb-0">Уведомление о задолженности</h3>
        </template>
                    По указанному Вами адресу, {{ address }}, образовалась задолженность перед {{ senderTitle }} в сумме {{ notice.amount_owed }} ₸.
        <template #footer>
                    <button class="btn btn-secondary" data-bs-dismiss="modal" @click="viewNotice">Просмотреть</button>
                    <button class="btn btn-danger" data-bs-dismiss="modal" @click="handleClose">{{ $t('close') }}</button>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal.vue'

export default {
    components: {
        BaseModal
    },
    name: 'debtNoticePreviewModal',
    data: () => ({
        modalId: 'debtNoticePreviewModal',
        notice: {},
        senderPhoneNumber: '',
        senderTitle: ''
    }),
    computed: {
        title: {
            get() {
                return this.$t('claim.title') + ' #'
            }
        },
        address: {
            get() {
                let str = this.notice.street + ' ' + this.notice.building_number
                str += this.notice.apartment ? `, ${this.notice.apartment}` : ''
                str += this.notice.extra ? `, ${this.notice.extra}` : ''
                return str
            }
        }
    },
    methods: {
        async read(id) {
            await this.$api.readNotice(id)
        },
        async getSenderPhone() {
            let url = process.env.VUE_APP_API_URL + '/recipients/sender-phone'
            
            await axios.get(url, {
                params: {
                    senderId: this.notice.sender
                },
                withCredentials: true
            }).then((response) => {
                this.senderPhoneNumber = response.data
            })
        },
        async getSenderTitle() {
            let url = process.env.VUE_APP_API_URL + '/recipients/sender-title'

            await axios.get(url, {
                params: {
                    senderId: this.notice.sender
                },
                withCredentials: true
            }).then(response => {
                this.senderTitle = response.data
            })
        },
        viewNotice() {
            this.$router.push(`/debt-notice/${this.notice.id}`)
            this.handleClose()
        },
        clear() {
            this.notice = {}
            this.senderPhoneNumber = ''
        },
        handleClose() {
            this.clear()
            this.$emit('closed')
        }
    },
}
</script>
